import React from 'react';
import PropTypes from 'prop-types';
import ChunkedUploadFile from '../Shared/ChunkedUploadFile';
import './SalesUploadFile.css';

const SALES_ROOT = process.env.REACT_APP_SALES_START_PATH || '/sales';

function SalesUploadFile({ currentPath, userId, onFileUploaded }) {
  return (
    <ChunkedUploadFile
      currentPath={currentPath}
      userId={userId}
      onFileUploaded={onFileUploaded}
      rootPath={SALES_ROOT}
      sessionPrefix="sales_file"
    />
  );
}

SalesUploadFile.propTypes = {
  currentPath: PropTypes.string,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onFileUploaded: PropTypes.func,
};

export default SalesUploadFile;
